export const streamConstants = {
    videoToBePlayedId: 'videoToBePlayedId'
};
